/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Seller_Calendar_Booking_FromInputs */

const en_seller_calendar_booking_from = /** @type {(inputs: Seller_Calendar_Booking_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Booking from ${i?.name}`)
};

const es_seller_calendar_booking_from = /** @type {(inputs: Seller_Calendar_Booking_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reserva de ${i?.name}`)
};

const fr_seller_calendar_booking_from = /** @type {(inputs: Seller_Calendar_Booking_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Réservation de ${i?.name}`)
};

const de_seller_calendar_booking_from = /** @type {(inputs: Seller_Calendar_Booking_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Buchung von ${i?.name}`)
};

const id_seller_calendar_booking_from = /** @type {(inputs: Seller_Calendar_Booking_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pemesanan dari ${i?.name}`)
};

/** @type {(inputs: Seller_Calendar_Booking_FromInputs) => LocalizedString} */
const ja_seller_calendar_booking_from = en_seller_calendar_booking_from;

/** @type {(inputs: Seller_Calendar_Booking_FromInputs) => LocalizedString} */
const zh_seller_calendar_booking_from = en_seller_calendar_booking_from;

/** @type {(inputs: Seller_Calendar_Booking_FromInputs) => LocalizedString} */
const ar_seller_calendar_booking_from = en_seller_calendar_booking_from;

/** @type {(inputs: Seller_Calendar_Booking_FromInputs) => LocalizedString} */
const it_seller_calendar_booking_from = en_seller_calendar_booking_from;

/** @type {(inputs: Seller_Calendar_Booking_FromInputs) => LocalizedString} */
const ru_seller_calendar_booking_from = en_seller_calendar_booking_from;

/** @type {(inputs: Seller_Calendar_Booking_FromInputs) => LocalizedString} */
const pt_seller_calendar_booking_from = en_seller_calendar_booking_from;

/** @type {(inputs: Seller_Calendar_Booking_FromInputs) => LocalizedString} */
const ko_seller_calendar_booking_from = en_seller_calendar_booking_from;

/**
* | output |
* | --- |
* | "Booking from {name}" |
*
* @param {Seller_Calendar_Booking_FromInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_calendar_booking_from = /** @type {((inputs: Seller_Calendar_Booking_FromInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Calendar_Booking_FromInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_calendar_booking_from(inputs)
	if (locale === "es") return es_seller_calendar_booking_from(inputs)
	if (locale === "fr") return fr_seller_calendar_booking_from(inputs)
	if (locale === "de") return de_seller_calendar_booking_from(inputs)
	if (locale === "ja") return ja_seller_calendar_booking_from(inputs)
	if (locale === "zh") return zh_seller_calendar_booking_from(inputs)
	if (locale === "ar") return ar_seller_calendar_booking_from(inputs)
	if (locale === "id") return id_seller_calendar_booking_from(inputs)
	if (locale === "it") return it_seller_calendar_booking_from(inputs)
	if (locale === "ru") return ru_seller_calendar_booking_from(inputs)
	if (locale === "pt") return pt_seller_calendar_booking_from(inputs)
	return ko_seller_calendar_booking_from(inputs)
});